var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-action btn-lg btn-primary btn-circle light-bottom-shadow",attrs:{"type":"button","data-bind":"click: action"},on:{"click":_vm.onClickActionButton}},[_c('i',{staticClass:"fas",class:[_vm.icon,_vm.size]})])
}
var staticRenderFns = []

export { render, staticRenderFns }